import { Wallet, TrendingUp, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { renderQuota } from '@/utils/quota'

interface AccountStatsCardProps {
  quota?: number
  usedQuota?: number
  group?: string
}

export default function AccountStatsCard({ quota, usedQuota, group }: AccountStatsCardProps) {
  const { t } = useTranslation()

  const stats = [
    { label: t('tt.topup.currentBalance'), value: renderQuota(quota), icon: Wallet, tone: 'bg-[#EEF2FF] text-[#4F46E5]' },
    { label: t('tt.topup.totalUsed'), value: renderQuota(usedQuota), icon: TrendingUp, tone: 'bg-[#EDE9FE] text-[#7C3AED]' },
    { label: t('tt.topup.userGroup'), value: group || 'default', icon: Users, tone: 'bg-[#CFFAFE] text-[#0891B2]' },
  ]

  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#E2E8F0] shadow-card">
      <div
        className="absolute inset-0 opacity-90"
        style={{
          background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 55%, #0891B2 100%)',
        }}
      />
      <div className="relative z-10 p-6">
        <h3 className="text-white text-[15px] font-semibold mb-4">{t('tt.topup.accountOverview')}</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {stats.map((item) => (
            <div key={item.label} className="text-center sm:text-left">
              <div className={`inline-flex w-9 h-9 rounded-lg items-center justify-center mb-2 ${item.tone}`}>
                <item.icon size={18} />
              </div>
              <div className="text-white/80 text-xs mb-1">{item.label}</div>
              <div className="text-white text-xl sm:text-2xl font-bold tabular-nums tracking-tight truncate">
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
